<template>
  <div>
    <page-header title="Settings" breadcrumb="CRM > Settings" />
    <div class="flex mt-12">
      <div
        class="tab-item "
        :class="{ active: currentTab == 'contact' }"
        @click="currentTab = 'contact'"
      >
        <p>Contact</p>
      </div>

      <div
        class="tab-item"
        :class="{ active: currentTab == 'loyalties' }"
        @click="currentTab = 'loyalties'"
      >
        <p>Loyalties</p>
      </div>
      <div
        class="tab-item"
        :class="{ active: currentTab == 'price-preferences' }"
        @click="currentTab = 'price-preferences'"
      >
        <p>Price References</p>
      </div>
      <div
        class="tab-item"
        :class="{ active: currentTab == 'industries-and-products' }"
        @click="currentTab = 'industries-and-products'"
      >
        <p>Industry & Products</p>
      </div>
      <div
        class="tab-item"
        :class="{ active: currentTab == 'pipeline-settings' }"
        @click="currentTab = 'pipeline-settings'"
      >
        <p>Pipeline Settings</p>
      </div>
    </div>
    <hr class="mb-6 mt-2" />
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Contact from "./Tabs/Contact";
import Loyalties from "./Tabs/Loyalties";
import PricePreferences from "./Tabs/PriceReferences";
import IndustriesAndProducts from "./Tabs/IndustryAndProducts";
import PipelineSettings from "./Tabs/Pipeline";

export default {
  components: {
    PageHeader,
    Contact,
    Loyalties,
    PricePreferences,
    IndustriesAndProducts,
    PipelineSettings,
  },
  data() {
    return {
      currentTab: "contact",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #10233e;
    font-weight: bold;
  }
}
</style>
